export default __webpack_public_path__ + "images/abea98a743a65a03bbc02ac4e4c95083.svg";